import { useNavigate } from 'react-router-dom'

export const PRINTER_URL = '/utils/printer'

export const useGoToPrinter = () => {
  const navigate = useNavigate()

  return {
    go: () => {
      navigate(PRINTER_URL)
    }
  }
}
